import { render, staticRenderFns } from "./RecommendPopup.vue?vue&type=template&id=22212618&scoped=true"
import script from "./RecommendPopup.vue?vue&type=script&lang=js"
export * from "./RecommendPopup.vue?vue&type=script&lang=js"
import style0 from "./RecommendPopup.vue?vue&type=style&index=0&id=22212618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22212618",
  null
  
)

export default component.exports